<template>
  <div>
    <button type="button" class="generic-button" @click="backClick">          
          <span class="button__icon">
              <ion-icon name="arrow-back-circle-outline"></ion-icon>
          </span>
          <span class="button__text">Επιστροφή</span>
      </button>
  </div>
</template>

<script>
import router from "../../router";

export default {
  props: ["returnUrl"],
  
  components: { },
  
  name:'backButton',
  
  data() {
    return {};
  },

  computed: {},

  methods: {
    backClick() {
      router.replace(this.returnUrl);
    },
  },
  async mounted() {},
};
</script>